<template>
  <div>
    <el-dialog title="批量导入" :visible.sync="visible" :before-close="handleClose" width="35%">
      <el-form :model="upForm" :rules="rules" ref="upForm" label-width="auto" size="mini">
        <el-form-item label="活动基本信息" prop="key">
          <el-upload
            :action="`${this.$store.state.upBaseUrl}coupon-market/activity_active/upload`"
            :headers="myHeaders"
            :limit="1"
            ref="infoUpload"
            accept=".csv"
            :on-success="handleAvatarSuccess"
            :auto-upload="true">
            <el-button slot="trigger" size="mini" type="primary">导入数据</el-button>
            <!-- <el-button style="margin-left: 10px;" size="small" type="success">下载模板</el-button> -->
            <div slot="tip" class="el-upload__tip">请选择导入活动，仅支持CSV格式</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="消费应用范围" prop="range">
          <el-radio-group v-model="upForm.range" @change="onRange">
            <el-radio label="全平台应用"></el-radio>
            <el-radio label="指定应用"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="导入应用" v-show="upForm.dvisible">
          <el-upload
            :action="`${this.$store.state.upBaseUrl}coupon-market/activity/fileUpload`"
            :headers="myHeaders"
            :limit="1"
            ref="applyUpload"
            accept=".txt"
            :on-success="handleApplyAvatarSuccess"
            :auto-upload="true">
            <el-button slot="trigger" size="mini" type="primary">导入数据</el-button>
            <div slot="tip" class="el-upload__tip">请选择导入应用，仅支持TXT格式</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="指定机型">
          <sam-phone-model @setPhoneModel="handlePhoneModel" ref="childModel"></sam-phone-model>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PhoneModel from '../phoneModel'

export default {
  components:{
      'sam-phone-model':PhoneModel
  },
  props: {
    visible: Boolean
  },
  data () {
    return {
      upForm: {
        key: '',
        range:'',
        dvisible:false,
        applyList:[],//指定应用时 上传的应用列表
        modelData:[],//已选机型列表
        myHeaders: {}
      },
      rules: {
        key: [
          { required: true, message: '请选择活动基本信息', trigger: 'blur' }
        ],
        range: [
          { required: true, message: '请选择消费应用范围', trigger: 'change' }
        ]
      }
    }
  },
  created(){
    var token =  window.sessionStorage.getItem('token');
    this.myHeaders = {'oa-token':token}
  },
  methods: {
    resetForm(){
      this.upForm = {key: '',range:'',dvisible:false,applyList:[],modelData:[]}
      this.$refs.childModel.handleClear();
      this.$refs.applyUpload.clearFiles();
      this.$refs.infoUpload.clearFiles();
      // this.$refs.upForm.resetFields();
    },
    //上传文件处理
    handleAvatarSuccess(res, file) {
      if (res.code == 0) {
        this.upForm.key = res.data
        this.$alert('上传成功!', '提示', {
          confirmButtonText: '确定',
        });
      }
    },
    handleApplyAvatarSuccess(res, file) {
      if (res.code == 0) {
        this.upForm.applyList = res.data
        this.$alert('上传成功!', '提示', {
          confirmButtonText: '确定',
        });
      }
    },
    handlePhoneModel(models){
      this.upForm.modelData = models;
    },
    //关闭
    handleClose() {
      this.$parent.handleUploadOpenOrClosed();
    },
    onRange(value){
      if (value === "指定应用") {
        this.upForm.dvisible = true;
      }else {
        this.upForm.dvisible = false;
      }
    },
    handleSubmit(){
      let _this = this;
      _this.$refs.upForm.validate((valid) => {
        if (valid) {
          this.$ajax({
            url:"coupon-market/activity_active/batch",
            async:false,
            methods:'POST',
            data:_this.upForm,
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code == 0 && response.data == 'SUCCESS') {
                _this.resetForm();
                _this.handleClose();
                _this.$parent.query();
              }else{
                _this.$message.error(response.message);
              }
            },
            error:function(){
              _this.$message.error("请求失败");
            }
          })
        } else {
          return false;
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/activityUpload.vue